import { NavBar } from '../../../../themes/components/Navbar';
import { Sidebar } from '../../../../themes/components/Sidebar';
import { Toaster } from 'react-hot-toast';
import { BuscaPedidos } from '../../components/BuscaPedidos';
import { TabelaListaPedidos } from '../../components/TabelaListaPedidos';

export const ConsultarPedidos = () => {
    return (
        <div className="site">
            <Sidebar />
            <div className="main-content">
                <div className="main-content-novo-pedido">
                    <NavBar />
                    <span className="novo-pedido-title-form">Busca de Pedidos</span>
                    <BuscaPedidos />
                    <span className="novo-pedido-title-form">Lista de Pedidos</span>
                    <TabelaListaPedidos />
                </div>
            </div>
            <Toaster />
        </div>
    )
}